// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const MsiIcon = createSvgIcon(
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24">
    <path fill="#F1511B" d="M9.5 9.5H0V0h9.5z" />
    <path fill="#80CC28" d="M20 9.5h-9.5V0H20z" />
    <path fill="#00ADEF" d="M9.5 20H0v-9.5h9.5z" />
    <path fill="#FBBC09" d="M20 20h-9.5v-9.5H20z" />
  </svg>,
  "Msi",
);
export default MsiIcon;
